import { c as _c } from "react/compiler-runtime";
import type { VaultValue } from '@onefootprint/core';
import { IcoPinMarker24 } from '@onefootprint/icons';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { DialogPage, LoadingSpinner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useInitializeStreetView from './utils/use-initialize-street-view';
import useStreetViewPanorama from './utils/use-street-view-panorama';
type StreetViewDialogProps = {
  onClose: () => void;
  addressValues: Partial<Record<DataIdentifier, VaultValue>>;
};
const StreetViewDialog = t0 => {
  const $ = _c(29);
  const {
    onClose,
    addressValues
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.address.streetView"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const streetViewRef = useRef(null);
  const addressLine1 = addressValues["id.address_line1"] || "";
  const addressLine2 = addressValues["id.address_line2"] || "";
  const city = addressValues["id.city"] || "";
  const state = addressValues["id.state"] || "";
  const zip = addressValues["id.zip"] || "";
  const address = `${addressLine1}${addressLine2 ? ` ${addressLine2}` : ""} ${city} ${state} ${zip}`;
  const streetViewQuery = useInitializeStreetView(address);
  const {
    isFetching
  } = useStreetViewPanorama(streetViewQuery.data, streetViewRef);
  let t2;
  if ($[1] !== addressLine1 || $[2] !== addressLine2) {
    t2 = () => `${addressLine1}${addressLine2 ? ` ${addressLine2}` : ""}`;
    $[1] = addressLine1;
    $[2] = addressLine2;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getFormattedAddress = t2;
  let t3;
  if ($[4] !== city || $[5] !== state || $[6] !== zip) {
    t3 = () => {
      const cityState = [city, state].join(", ");
      return [cityState, zip].join(" ");
    };
    $[4] = city;
    $[5] = state;
    $[6] = zip;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getFormattedCityStateZip = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isFetching) {
    t5 = isFetching && <div className="absolute top-0 left-1/2 right-0 bottom-0 flex justify-center items-center z-1000"><LoadingSpinner /></div>;
    $[10] = isFetching;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = !isFetching;
  let t7;
  if ($[12] !== isFetching || $[13] !== t6) {
    t7 = cx("w-100vw h-[calc(100dvh-72px)] overflow-hidden rounded-b-default", {
      hidden: isFetching,
      block: t6
    });
    $[12] = isFetching;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div ref={streetViewRef} className={t7} />;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== getFormattedAddress || $[18] !== getFormattedCityStateZip || $[19] !== streetViewQuery.isSuccess) {
    t9 = streetViewQuery.isSuccess && <div className="absolute bg-primary rounded-default pl-2 pr-3 py-2 transform -translate-x-1/2 left-1/2 bottom-6 z-1000 flex flex-col gap-2 items-center"><IcoPinMarker24 /><div className="flex flex-col gap-0"><div className="text-label-2 text-primary" data-dd-privacy="mask">{getFormattedAddress()}</div><div className="text-body-2 text-tertiary" data-dd-privacy="mask">{getFormattedCityStateZip()}</div></div></div>;
    $[17] = getFormattedAddress;
    $[18] = getFormattedCityStateZip;
    $[19] = streetViewQuery.isSuccess;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <div className="relative h-full max-md:h-[calc(100dvh-44px)]">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onClose || $[25] !== t10 || $[26] !== t4 || $[27] !== t5) {
    t11 = <DialogPage onClose={onClose} title={t4} noPadding={true}>{t5}{t10}</DialogPage>;
    $[24] = onClose;
    $[25] = t10;
    $[26] = t4;
    $[27] = t5;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};
export default StreetViewDialog;
function _temp($) {
  return $.title;
}